"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * 深断言
 * @param {array|object} data1 数据1
 * @param {array|object} data2 数据2
 */
// eslint-disable-next-line import/prefer-default-export
var deepAsset = exports.deepAsset = function deepAsset(data1, data2) {
  return JSON.stringify(data1) === JSON.stringify(data2);
};